import { render } from "./LayoutVertical.vue?vue&type=template&id=5ff02382"
import script from "./LayoutVertical.vue?vue&type=script&lang=js"
export * from "./LayoutVertical.vue?vue&type=script&lang=js"
script.render = render

export default script